import React, { useState } from 'react';
import '../styles/ContactForm.css';
import Footer from "./Footer";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setSubmitMessage({
        type: 'success',
        text: 'Bericht verzonden! We nemen spoedig contact met je op.'
      });
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      setSubmitMessage({
        type: 'error',
        text: 'Sorry! Er is iets misgegaan. Probeer het opnieuw.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="contact-page">
        <div className="contact-container">
          <section className="contact-intro">
            <h1>📬 Neem contact op</h1>
            <p>Heb je vragen, feedback of hulp nodig?</p>
            <p>Wij bij Firgoquast horen graag van je!</p>
            <p>Of het nu gaat om verantwoord spelen, privacy, technische problemen of samenwerking – wij staan voor je klaar. 🙌</p>
          </section>

          <div className="contact-grid">
            <section className="contact-info">
              <div className="info-card">
                <h2>🧾 Algemeen contact</h2>
                <ul>
                  <li><span>📧</span> <strong>E-mail:</strong> meister@gmail.com</li>
                  <li><span>📞</span> <strong>Telefoon:</strong> +47 22 83 70 10</li>
                  <li>
                    <span>📍</span> <strong>Adres:</strong><br />
                    Firgoquast AS<br />
                    Dronning Eufemias gate 16<br />
                    0191 Oslo, Noorwegen
                  </li>
                  <li>
                    <span>🕒</span> <strong>Openingstijden:</strong><br />
                    Maandag–Vrijdag: 09:00–17:00<br />
                    Zaterdag–Zondag: Gesloten
                  </li>
                </ul>
              </div>

              <div className="info-card important-info">
                <h2>💡 Belangrijke informatie</h2>
                <p>Firgoquast biedt alleen gratis sociale casinospellen aan voor entertainment.</p>
                <p>Er zijn geen kansspelen, geen aankopen en geen geldprijzen op dit platform.</p>
                <p>Voor vragen over verantwoord spelen raden wij aan om te kijken op <a href="http://www.hjelpelinjen.no" target="_blank" rel="noopener noreferrer">www.hjelpelinjen.no</a>.</p>
              </div>

              <div className="info-card privacy-info">
                <h2>🛡️ Privacy</h2>
                <p>Benieuwd hoe wij jouw gegevens verwerken?</p>
                <p>Lees ons <a href="/personvernregler">Privacybeleid</a> en onze <a href="/tjenestevilkår">Gebruiksvoorwaarden</a> voor alle details.</p>
              </div>
            </section>

            <section className="contact-form-section">
              <h2>✍️ Stuur ons een bericht</h2>
              {submitMessage && (
                <div className={`message ${submitMessage.type}`}>
                  {submitMessage.text}
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Jouw naam"
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Jouw e-mailadres"
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Onderwerp"
                  />
                </div>
                
                <div className="form-group">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Jouw bericht"
                    rows="5"
                  ></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Verzenden...' : 'Bericht verzenden'}
                </button>
              </form>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};


export default ContactForm;
